import React, { Component } from 'react';

class getCItems extends Component {

  mostrarItems = () => {
    const items = this.props.items;
    if(items.length === 0) return null;
    return (
      <React.Fragment>
        {items.map((item,index) => (
          
          <button 
          onClick={ () => this.props.additem(item.id_producto,item.producto,item.precio_venta,
          item.descripcion,item.uuid_imagen,item.combo,item.sw_iva)}
          >{item.producto}</button>
        ) ) }
      </React.Fragment>
    )
    // <span key={index} className="boton_item"> </span> className="boton_item_span"
  }

  render() {
    const items = this.props.items
    let data
    if(items.length===0){
      data =<div className="div_lbl_loading"><img alt="Cargando Imagen . . ."
      className="lbl_loading" src={ require('../image/loading.gif') } /></div>
    }else{
      data = <React.Fragment>{this.mostrarItems()}</React.Fragment>
    }
    return (
      <React.Fragment>
      {data}
      </React.Fragment>
    );
  }
}
export default getCItems;
